import * as React from "react";
import { CarouselBlock } from "../../Pages/Ecommerce/Shared/CarouselBlock/CarouselBlock";
import { CollectionListItem } from "../../Pages/CollectionNewSearchPage/CollectionListItem/CollectionListItem";

interface Model {
    title: string;
    buttonText: string;
    buttonUrl: string;
    getObjectsByInvNosEndpoint: string;
    invNos: string[];
    linkToObjectPage: string;
}

interface Translations {
    outOf: string;
    next: string;
    previous: string;
}

interface Props {
    model: Model;
    translations: Translations;
}

export interface ICollectionListItem {
    title: string;
    medium: string;
    primaryMedia: string;
    mediaId: string;
    imageUrl?: string;
    displayDate: string;
    invNo: string;
    linkToObjectPage: string;
    partOfExhibitions?: { exhibitionTitle: string; exhibitionPageLink: string }[];
    isVirtualObject: boolean;
    numberOfChildren: number;
    childrenPrimaryMedia: string[];
    onDisplayLabel?: string;
}

export const KeyWorksCarousel: React.FC<Props> = ({ model, translations }) => {
    const [items, setItems] = React.useState<ICollectionListItem[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | null>(null);

    const query = React.useMemo(() => model.getObjectsByInvNosEndpoint, [model]);

    React.useEffect(() => {
        let abort = false;
        if (!model?.invNos?.length || !query) {
            setItems([]);
            return;
        }

        (async () => {
            try {
                setLoading(true);
                setError(null);

                const body = new URLSearchParams();
                for (const n of model.invNos) body.append("invnos", n);

                const res = await fetch(query, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
                    body: body.toString(),
                });
                if (!res.ok) throw new Error(`Failed to fetch objects (${res.status})`);
                const data: ICollectionListItem[] = await res.json();
                console.log(data);
                if (abort) return;
                setItems(data);
            } catch (e) {
                if (!abort) setError(e instanceof Error ? e.message : String(e));
            } finally {
                if (!abort) setLoading(false);
            }
        })();

        return () => {
            abort = true;
        };
    }, [query, model?.invNos]);

    return (
        <div>
            <CarouselBlock
                title={model.title}
                bgColor="white"
                fullWidth
                previousSlideAriaLabel={translations.previous}
                nextSlideAriaLabel={translations.next}
                buttonText={model.buttonText}
                buttonUrl={model.buttonUrl}
                itemsPerSlideDesktop={3}
                itemsPerSlideMobile={2.5}
                displayData={items.map((item) => ({
                    key: item.invNo || item.mediaId || item.title,
                    data: <CollectionListItem isKeyWorksCarousel linkToObjectPage={model.linkToObjectPage} {...item} />,
                }))}
            />
        </div>
    );
};
